// hostUrl/domainUrl are env-driven for local dev (REACT_APP_*), with the
// production values as the default when the env vars are absent.
// export const hostUrl = "https://api.chips.social";
export const hostUrl =
  process.env.REACT_APP_HOST_URL || "https://api.channels.social";
// export const hostUrl = "http://localhost:3000";
// export const hostUrl = "http://192.168.1.3:3000";

// export const domainUrl = "localhost:3001";
// export const domainUrl = "chips.org.in";
export const domainUrl =
  process.env.REACT_APP_DOMAIN_URL || "channels.social";
